'use strict';

const urlHelper = require('../utils/urlHelper');
const createErrorNotification = require('../components/errorNotification');
const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    body: 'body',
    deleteLookModal: '#deleteLookModal',
    lookToRemove: '.js-look-to-remove',
    deleteLookBtn: '.js-delete-look-btn',
    generalErrorContainer: '.error-messaging',
}

/**
 * Handle 'DeleteLookModal' Modal Open
 * @returns {void}
 */
const handleDeleteLookModalOpen = (e) => {
    $(SELECTORS.lookToRemove).text($(e.relatedTarget).attr('data-lookname')).removeClass(CLASSES.hide);
    $(SELECTORS.deleteLookBtn).attr('data-lookid', $(e.relatedTarget).attr('data-lookid'));
    $(SELECTORS.deleteLookBtn).attr('data-eventregno', $(e.relatedTarget).attr('data-eventregno'));
}

/**
 * Handle Delete the Look button click
 * @returns {void}
 */
const handleDeleteTheLook = (e) => {
    e.preventDefault();

    $(SELECTORS.deleteLookModal).spinner().start();
    let url = $(e.target).attr('data-url');
    url = urlHelper.appendToUrl(url, {
        removeId: $(e.target).attr('data-lookid'),
        eventRegNo: $(e.target).attr('data-eventregno') || '',
    });

    $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: (response) => {
            $(SELECTORS.deleteLookModal).spinner().stop();

            if (response.redirectUrl) {
                window.location = response.redirectUrl;
                return;
            }

            if (response.success) {
                window.location.reload();
            }

            if (response.error) {
                createErrorNotification($(SELECTORS.generalErrorContainer), response.errorMessage);
            }
        }
    });
}


/**
 * Init events
 * @returns {void}
 */
function handleDeleteLook() {
    $(SELECTORS.body).on('click', SELECTORS.deleteLookBtn, handleDeleteTheLook);
    $(SELECTORS.deleteLookModal).on('show.bs.modal', handleDeleteLookModalOpen);
}

module.exports = {
    handleDeleteLook: handleDeleteLook,
};

